export default __webpack_public_path__ + "static/media/image21.aaaae8a9.jpg";